export default __webpack_public_path__ + "static/media/Gucci.c90f16d5.png";